import React from 'react';
import { observable, action, computed, configure, toJS } from 'mobx';
import { Cerchio, CieloTerra, Porzioni, Stella, Quadrato, Rombo, Direct, Triangolo, Core, Development, Opportunistic, Trophy, Valueadd, HSct, HSporz, PinGen, PinComp, PinFoto } from "./CustomIcons";

configure({ enforceActions: 'observed' }) // don't allow state modifications outside actions

let allPOIS = [
	{ latLng: {lat: 45.4628328, lng: 9.1876925 },
		label: 'Pin 1',
		title: 'PIIIIIIIIN',
		macroCatC: 'CIELO TERRA',
		macroCatB: 'Own Use',
		strategy: 'CORE',
		saleStrategy: 'Sell',
		destination: 'Office',
		}
	,{ latLng: {lat: 45.4848329, lng: 9.1756925 },
		label: 'Pin 2',
		title: 'PIIIIIIIIN',
		macroCatC: 'PORZIONI',
		macroCatB: 'Own Use',
		strategy: 'Trophy',
		saleStrategy: 'Sell',
		destination: 'Retail',
		}
	,{ latLng: {lat: 45.4768329, lng: 9.1816925 },
		label: 'Pin 3',
		title: 'PIIIIIIIIN',
		macroCatC: 'PORZIONI',
		macroCatB: 'Development Projects',
		strategy: 'Development',
		saleStrategy: 'Sell',
		destination: 'Other',
		}
	,{ latLng: { lat: 45.4878329, lng: 9.1986925 }, 
		label: 'Pin 4',  
		macroCatC: 'CIELO TERRA', 
		macroCatB: 'Development Projects', 
		strategy: 'Opportunistic', 
		saleStrategy: 'Hold',
		destination: 'Other',
	}
	,{ latLng: { lat: 45.4718329, lng: 9.2056925 }, 
		label: 'Pin 5',  
		macroCatC: 'CIELO TERRA', 
		macroCatB: 'Direct Investments', 
		strategy: 'VALUE ADD', 
		saleStrategy: 'Sell',
		destination: 'Residential',
	}
	,{ latLng: { lat: 45.4738329, lng: 9.1656925 }, 
		label: 'Pin 6',  
		macroCatC: 'PORZIONI', 
		macroCatB: 'AuM for 3rd Parties', 
		strategy: 'Opportunistic', 
		saleStrategy: 'Hold',
		destination: 'Office',
	}
	,{ latLng: { lat: 45.4818329, lng: 9.1456925 }, 
		label: 'Pin 7',  
		macroCatC: 'CIELO TERRA', 
		macroCatB: 'AuM for 3rd Parties', 
		strategy: 'Opportunistic', 
		saleStrategy: 'Sell' ,
		destination: 'Residential',
	}
	,{ latLng: { lat: 45.4918329, lng: 9.1636925 }, 
		label: 'Pin 8',  
		macroCatC: 'PORZIONI', 
		macroCatB: 'Own Use', 
		strategy: 'Development', 
		saleStrategy: 'Hold',
		destination: 'Office',
	}
	,{ latLng: { lat: 45.4528329, lng: 9.1596925 }, 
		label: 'Pin 9',  
		macroCatC: 'CIELO TERRA', 
		macroCatB: 'AuM for Pan EU Funds', 
		strategy: 'VALUE ADD', 
		saleStrategy: 'Sell',
		destination: 'Residential',
	}
	,{ latLng: { lat: 45.4588329, lng: 9.1656925 }, 
		label: 'Pin 10',  
		macroCatC: 'PORZIONI', 
		macroCatB: 'AuM for Pan EU Funds', 
		strategy: 'Trophy', 
		saleStrategy: 'Hold',
		destination: 'Retail',
	}
];

let COLUMNS_AND_VALUES_MAP = {
	'macroCatC': [
		{ icon: <CieloTerra/>, label: 'Cielo/Terra', value: 'CIELO TERRA' }
		,{ icon: <Porzioni/>, label: 'Porzioni', value: 'PORZIONI' }
	]
	,'macroCatB': [
		{ icon: <Stella/>, label: 'Own Use', value: 'Own Use' }
		,{ icon: <Triangolo/>, label: 'Development projects', value: 'Development Projects' }
		,{ icon: <Direct/>, label: 'Direct Investments', value: 'Direct Investments' }
		,{ icon: <Quadrato/>, label: 'AuM for Pan EU Funds', value: 'AuM for Pan EU Funds' }
		,{ icon: <Rombo/>, label: 'AuM for 3rd parties', value: 'AuM for 3rd Parties' }
	]
	,'strategy': [
		{ icon: <Core/>, label: 'Core', value: 'CORE' }
		,{ icon: <Development/>, label: 'Development', value: 'Development' }
		,{ icon: <Opportunistic/>, label: 'Opportunistic', value: 'Opportunistic' }
		,{ icon: <Trophy/>, label: 'Trophy', value: 'Trophy' }
		,{ icon: <Valueadd/>, label: 'Value Add', value: 'VALUE ADD' }
	]
	,'saleStrategy': [
		{ icon: <HSct/>, label: 'Hold', value: 'Hold' }
		,{ icon: <HSporz/>, label: 'Sell', value: 'Sell' }
	]
	,'destination': [
		{ icon: null, label: 'Office', value: 'Office' }
		,{ icon: null, label: 'Retail', value: 'Retail' }
		,{ icon: null, label: 'Residential', value: 'Residential' }
		,{ icon: null, label: 'Other', value: 'Other' }
	]
}

class AppStateStore {
	@observable panelMode = 'filter';
	@observable filterValue;
	@observable filterPanelShowList = false;

	@observable filters = {}
	@observable allFilterGroups = [];
	@observable colorGroup;

	@observable allPOIS= allPOIS;
	@computed get filteredPOIS() {
		return this.allPOIS.filter( (item) => {
			let isVisible = true;
			Object.entries(this.filters).forEach( ([key, filterValue]) => {
				if (filterValue && filterValue.length > 0 && filterValue.indexOf(item[key]) == -1){
					isVisible = false;
				}
			});
			return isVisible;
		});
	}
	@observable COLUMNS_AND_VALUES_MAP = COLUMNS_AND_VALUES_MAP;

	activateScreenshotPanel = action( () => {
		this.panelMode = 'screenshot';
	});
	activateFilterPanel = action( () => {
		this.panelMode = 'filter';
	});
	activateSearchPanel = action( () => {
		this.panelMode = 'search';
	});

	setSearchValue = action( (v) => {
		this.filterValue = v;
	});

	toggleFilterPanelList = action( () => {
		this.filterPanelShowList = !this.filterPanelShowList;
	});

	/*setFilter = action( (group, key, value) => {
		if (!this.filters[group]){
			this.filters[group] = {};
		}
		this.filters[group][key] = value;
		console.log(toJS(this.filters));
	});*/

	setGroupFilter = action( (group, values) => {
		this.filters[group] = values;
		console.log(toJS(this.filters));
	});

	setAllGroupFilter = action( (group, value) => {
		console.log('set all group filter', value);
		if (value){
			if (this.allFilterGroups.indexOf(group) == -1){
				this.allFilterGroups.push(group);
			}
		}
		else {
			this.allFilterGroups.remove(group);
		}
		//console.log(toJS(this.allFilterGroups));
		//console.log(toJS(this.filters));
	});

	setColorGroup = action( (group, checked) => {
		console.log(group, checked);
		this.colorGroup = (checked ? group : null);
	});

}

export default AppStateStore;
